(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  // Özel sayfa: Ürün kataloğu (Kategoriler + Urun) — catalog.min.js.
  // common + inner üstüne eklenir; akordeon, ürün slider'ı ve galeri.
  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("Accordion", function () { DNB.Accordion.init(); });
    DNB.safeInit("ProductSlider", function () { DNB.ProductSlider.init(); });
    DNB.safeInit("Gallery", function () { DNB.Gallery.init(); });
    DNB.safeInit("CatalogDownload", function () { DNB.CatalogDownload.init(); });
  });
})(window, document);
